import { render, staticRenderFns } from "./QuoteTreatmentsForm.vue?vue&type=template&id=51ef767e&scoped=true&"
import script from "./QuoteTreatmentsForm.vue?vue&type=script&lang=js&"
export * from "./QuoteTreatmentsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51ef767e",
  null
  
)

export default component.exports